export const firebaseConfig = {
  apiKey: "AIzaSyDE1LLG5Cnc2XdyQAvb4Vwf3iUwSAOrqTU",
  authDomain: "voice-tv-membership-portal.firebaseapp.com",
  projectId: "voice-tv-membership-portal",
  storageBucket: "voice-tv-membership-portal.appspot.com",
  messagingSenderId: "548397690181",
  appId: "1:548397690181:web:78ec712d2893d4b0cda22c",
  measurementId: "G-131GLJNM51"
};
